var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-popover',{ref:"popoverInfo1",attrs:{"tabindex":"1","target":("marker" + (_vm.marker.id)),"triggers":"focus"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Danger!")]},proxy:true}])},[_vm._v(" Danger variant popover ")])}
var staticRenderFns = []

export { render, staticRenderFns }